import React, { useRef, useEffect, useState } from "react";
import { Container } from "@pixi/react";
import BasicTexture from "../../../Elements/Textures/BasicTexture";
import anime from "animejs";
import { BitmapText } from "@pixi/react";
import { useSelector } from "react-redux";
import { animateTextCounter, formatToCustomLocale } from "../../../utilities"; // Assuming you have these utilities

const FeatureWinsDisplay = ({ width, height, x, y, zIndex }) => {
  const displayBackgroundRef = useRef(null);
  const textRef = useRef(null);
  const { totalFreeSpinWin } = useSelector((state) => state.game);
  const { spinComplete } = useSelector((state) => state.spin);

  const [previousWins, setPreviousWins] = useState(totalFreeSpinWin); // Track previous wins state

  useEffect(() => {
    if (displayBackgroundRef.current) {
      const animation = anime({
        targets: displayBackgroundRef.current,
        y: [
          { value: `+=4`, duration: 1500, easing: "easeInOutSine" },
          { value: `-=4`, duration: 1500, easing: "easeInOutSine" },
        ],
        loop: true,
        direction: "alternate",
      });

      return () => animation.pause(); // Cleanup to pause animation
    }
  }, []);

  useEffect(() => {
    if (previousWins !== totalFreeSpinWin && spinComplete) {
      // Trigger the counter animation
      animateTextCounter(
        textRef,
        previousWins,
        totalFreeSpinWin,
        1000, // Duration of the animation
        (animatedValue) => `${formatToCustomLocale(animatedValue)}`
      );

      setPreviousWins(totalFreeSpinWin); // Update previousWins to the new value

      // When animation completes, perform any necessary actions
      setTimeout(() => {
        // You can add any other logic here if needed
      }, 1000); // Match animation duration
    }
  }, [totalFreeSpinWin, spinComplete, previousWins]);

  return (
    <Container name="FreeSpinsWinsDisplay" x={x} y={y} zIndex={zIndex}>
      <BasicTexture
        ref={displayBackgroundRef}
        textureName="featureReelBottom"
        width={width}
        height={height}
        zIndex={2}
      />

      {previousWins > 0 && (
        <BitmapText
          ref={textRef}
          zIndex={5}
          text={`${formatToCustomLocale(previousWins)}`}
          anchor={0.5}
          style={{
            fontName: `jackpot-diamond`,
            fontSize: 24,
            fill: "#ffffff",
            fontWeight: "bold",
            align: "center",
          }}
        />
      )}
    </Container>
  );
};

export default FeatureWinsDisplay;
